import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  useListaCidadesService,
  useProjetosService,
} from "../../../../../../../../use-cases/geo-veles";
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { useEffect, useState } from "react"; // ← adicionado useState
import { CreateListaCidadesForm, EditListaCidadesForm } from "./forms";
import { PreviaFiltroLocalizacao } from "../previa-filtro-localizacao";
import { theme } from "../../../../../../../styles";
// Icons
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import { cidadeListLenghtToLabel } from "../../../../../../../../utils";

export const ListasCidades = (props: { purge: boolean; searchTerm: string }) => {
  // Função para contar cidades
  const getCidadesCountFromData = (cidadesData: string | string[] | undefined): number => {
    if (!cidadesData) return 0;
    if (Array.isArray(cidadesData)) return cidadesData.length;
    if (typeof cidadesData === 'string') {
      try {
        const parsed = JSON.parse(cidadesData);
        if (Array.isArray(parsed)) return parsed.length;
        if (parsed && parsed.data && Array.isArray(parsed.data)) return parsed.data.length;
        return 0;
      } catch (error) {
        return 0;
      }
    }
    return 0;
  };

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [cidadeListToDelete, setCidadeListToDelete] = useState<{
    id: number;
    nome: string;
    idUsuario: number;
  } | null>(null);

  // State
  const { listaCidades, projetos } = useAppSelector((state) => state);

  // Hook
  const { addListaCidadesFilter, addPurgeListaCidadesFilter } = useProjetosService();
  const {
    openCreateListaCidadesForm,
    selectListaCidadesToEdit,
    setupListaCidades,
    updateListaCidadesStatus,    
  } = useListaCidadesService();

  
  useEffect(() => {
    setupListaCidades();
  }, []);


  const handleConfirmDelete = async () => {
    if (cidadeListToDelete) {
      try {
        await updateListaCidadesStatus({
          IdVelesGeoListaCidade: cidadeListToDelete.id,
          idUsuario: cidadeListToDelete.idUsuario,
          status: false, // soft delete
        });

      } catch (error) {
        console.error("Erro ao excluir lista:", error);
      } finally {
        setConfirmDeleteOpen(false);
        setCidadeListToDelete(null);
      }
    }
  };

  return (
    <>
      <Box pl={3}>
        <form onSubmit={(e) => e.preventDefault()}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Button
                fullWidth
                onClick={(e) => {
                  e.preventDefault();
                  openCreateListaCidadesForm(true);
                }}
                startIcon={<AddIcon />}
              >
                Criar nova lista de Cidades
              </Button>
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                onClick={() => {
                  const listasCidades = listaCidades?.listasCidades ?? [];
                  if (props.purge) {
                    listasCidades.forEach((cidade) =>
                      addPurgeListaCidadesFilter(cidade.IdVelesGeoListaCidade)
                    );
                  } else {
                    listasCidades.forEach((cidade) =>
                      addListaCidadesFilter(cidade.IdVelesGeoListaCidade)
                    );
                  }
                }}
              >
                Incluir todas as listas
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>

      <Grid container>
        <Grid item xs={6}>
          <List>
            {(listaCidades?.listasCidades ?? [])
              .filter((cidadeList) => {
                if (projetos?.filtrosSelecionados) {
                  if (
                    projetos.filtrosSelecionados.listasCidades?.includes(
                      cidadeList.IdVelesGeoListaCidade
                    )
                  ) return false;
                  if (
                    projetos.filtrosSelecionados.purgeListasCidades?.includes(
                      cidadeList.IdVelesGeoListaCidade
                    )
                  ) return false;
                }
                if (!cidadeList.Ativa) return false;
                if (props.searchTerm === "") return true;
                return cidadeList.Nome?.toUpperCase().includes(
                  props.searchTerm.toUpperCase()
                );
              })
              .map((cidadeList) => (
                <div key={cidadeList.IdVelesGeoListaCidade}>
                  <ListItem
                    secondaryAction={
                      <>
                        <Button
                          startIcon={<EditIcon />}
                          onClick={(event) => {
                            event.stopPropagation();
                            selectListaCidadesToEdit(cidadeList.IdVelesGeoListaCidade);
                          }}
                        >
                          Editar
                        </Button>
                        <Button
                          startIcon={<DeleteIcon />}
                          onClick={(event) => {
                            event.stopPropagation();
                            setCidadeListToDelete({
                              id: cidadeList.IdVelesGeoListaCidade,
                              nome: cidadeList.Nome || "essa lista",
                              idUsuario: cidadeList.IdUsuario,
                            });
                            setConfirmDeleteOpen(true);
                          }}
                        >
                          Excluir
                        </Button>
                      </>
                    }
                    button
                    onClick={() => {
                      if (props.purge) {
                        addPurgeListaCidadesFilter(cidadeList.IdVelesGeoListaCidade);
                      } else {
                        addListaCidadesFilter(cidadeList.IdVelesGeoListaCidade);
                      }
                    }}
                  >
                    <ListItemText
                      primary={cidadeList.Nome?.toUpperCase()}
                      secondary={cidadeListLenghtToLabel(getCidadesCountFromData(cidadeList.Cidades))}
                    />
                  </ListItem>
                  <Divider color={theme.palette.primary.main} />
                </div>
              ))}
          </List>
        </Grid>

        {((projetos?.filtrosSelecionados?.localizacao?.length ?? 0) > 0 ||
          (projetos?.filtrosSelecionados?.purgeLocalizacao?.length ?? 0) > 0 ||
          (projetos?.filtrosSelecionados?.listasCidades?.length ?? 0) > 0 ||
          (projetos?.filtrosSelecionados?.purgeListasCidades?.length ?? 0) > 0) && (
            <Grid item xs={6}>
              <Box px={3}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h5" color="primary" fontWeight="bold" textTransform="uppercase">
                      Localizações selecionadas
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <PreviaFiltroLocalizacao />
                  </AccordionDetails>
                </Accordion>
              </Box>
            </Grid>
          )}
      </Grid>

      <CreateListaCidadesForm openForm={listaCidades.openCreateListaCidades} />
      <EditListaCidadesForm openForm={listaCidades.openEditListaCidades} />

  
      <Dialog
        open={confirmDeleteOpen}
        onClose={() => {
          setConfirmDeleteOpen(false);
          setCidadeListToDelete(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirmar exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir a lista{" "}
            <strong>{cidadeListToDelete?.nome}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmDeleteOpen(false);
              setCidadeListToDelete(null);
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            startIcon={<DeleteIcon />}
            variant="contained"
          >
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};